<script>
    export let options = [];
    export let index = 0;
    export let value;
    export let playing = false;
    export let btn_offset = 604;

	import { clickOutside } from '../../actions/clickOutside.js';
	import { scaleY } from '../../actions/scaleY.js';
    import MediaQuery from "./MediaQuery.svelte";
    import { slide } from 'svelte/transition';
  
    $: {
      value = options[index];
    }

/* Features needed to make the selectCustom work for mouse users.

- Toggle custom select visibility when clicking the "box"
- Update custom select value when clicking in a option
- Navigate through options when using keyboard up/down
- Pressing Enter or Space selects the current hovered option
- Close the select when clicking outside of it
- Sync both selects values when selecting a option. (native or custom)

*/

	let nativeFocused = false;
    export let showOptions = false;

    const onFocus = () => nativeFocused = true;
	const onBlur = () => nativeFocused = false;
	const selectOption = (i) => {
        index = i;
        showOptions = !showOptions;
    };
    const toggleOptions = (e) => { showOptions = !showOptions; }
    const triggerOptions = (e) => { showOptions = !showOptions; }


</script>


<div class="selectWrapper" style="left:{btn_offset+20}px;">

    <!-- Use default select to start -->
    <select bind:value={index} on:focus={onFocus} on:blur={onBlur} class="selectNative" aria-label="choose a race" style="{playing ? "filter: blur(2px); -webkit-filter: blur(2px); opacity: 0.7" : ""}">
        {#each options as option, i}
            <option value={i}>{option.race}</option>
        {/each}
    </select>

    <!-- If there is a mouse then cover with the trigger to use the custom select dropdown -->
    <MediaQuery query="(hover: hover)" let:matches>
        {#if matches && !nativeFocused}
            <div class="selectCustom" on:click="{triggerOptions}" style="{playing ? "filter: blur(2px); webkit-filter: blur(2px); opacity: 0.7" : ""}" >
                <div class="selectCustom-trigger" class:pressed="{showOptions}"></div>
            </div>  
        {/if}
    </MediaQuery>

</div>

{#if showOptions}
    <div class="backdrop"></div>
    <div class="selectCustom-options" use:clickOutside on:click_outside={toggleOptions} transition:scaleY="{{duration: 300}}">
        {#each options as option, i}
            <div class="selectCustom-option" on:click={() => selectOption(i)} class:isActive={index === i} data-value={i}>
                <div class="raceName">{option.race}</div>
                <div class="raceDate">{option.date}</div>
            </div>
        {/each}
    </div>
{/if}










<style>
    .backdrop {
        width: 100%;
        height: 170px;
        position: absolute;
        background: #00000000;
        z-index: 1;
        top: 0;
    }


    .selectWrapper {
        display: inline-block;
        position: absolute;
        top: 24px;
        transition: left 0.5s;
    }


    .selectNative {
        width: 40px;
        height: 40px;
        border-radius: 99px;
        border: 1px solid #343135;
        background-color: #00000000;
        padding-right: 15px;
        background-image: url("data:image/svg+xml;utf8,<svg width='11' height='7' viewBox='0 0 11 7' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L5.5 5.5L10 1' stroke='white' stroke-width='2'/></svg>");
        background-repeat: no-repeat;
        background-position: center;
        position: relative;
        -webkit-appearance: none;
        padding-right: 32px;

    }

    @media (hover: none) {    
        .selectNative {
            box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000;
        }
    }

    .selectNative:focus {
        -webkit-appearance: none;
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000, inset 1px 2px 2px rgba(0, 0, 0, 0.8), inset -1px -1px 2px rgba(255, 255, 255, 0.5);
    }

    .selectCustom {
        position: absolute;
        top: -1px;
        left: -1px;
    }

    .selectCustom-trigger {
        width: 40px;
        height: 40px;    
        -webkit-border-radius: 99px;
        -moz-border-radius: 99px;
        border-radius: 99px;
        color: #00000000;
        border: 1px solid #343135;
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000;
        background-image: url("data:image/svg+xml;utf8,<svg width='11' height='7' viewBox='0 0 11 7' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L5.5 5.5L10 1' stroke='white' stroke-width='2'/></svg>");
        background-repeat: no-repeat;
        background-position: center;
        position: absolute;
        display: block;
        cursor: pointer;
    }

    .selectCustom-trigger:hover {
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000, 0 0 0 2px #FF285D;
    }

    .selectCustom-trigger:active {
        box-shadow: inset 1px 2px 2px rgba(0, 0, 0, 0.8), inset -1px -1px 2px rgba(255, 255, 255, 0.5);
    }

    .pressed {
        box-shadow: inset 1px 2px 2px rgba(0, 0, 0, 0.8), inset -1px -1px 2px rgba(255, 255, 255, 0.5);
    }


    /* @media screen and (max-width: 750px) {
        .selectCustom-trigger, .selectNative {
            width: 25px;
            height: 25px;
        }
    } */

    .selectCustom-options {
        background: linear-gradient(135deg, #222427 0%, #1A1C20 100%);
        box-shadow: -1px -1px 6px rgba(155, 155, 155, 0.25), 10px 10px 24px #000000;
        border-radius: 10px;
        width: 650px;
        height: 550px;
        padding: 20px;
        position: absolute;
        z-index: 1;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        box-sizing: border-box;
    }

    .selectCustom-option {
        display: inline-block;
        margin: 0px 12px 10px;
        width: 300px;
    }


    .raceName {
        font-family: Poppins, sans-serif;
        font-style: italic;
        font-weight: 800;
        font-size: 24px;
        color: #222427;
        text-transform: uppercase;
        /* text-stroke: 1px #8f8f8f; */
        -webkit-text-stroke: 1px #8f8f8f;
        margin-bottom: 0px;
        line-height: 24px;
    }

    .raceDate {
        margin-top: 0px;
        font-family: Poppins, sans-serif;
        text-transform: uppercase;
        color: #CECECE;
        font-size: 12px;
        line-height: 12px;
    }



    .selectCustom-option:hover .raceName {
        /* text-stroke: 1px #FF285D; */
        -webkit-text-stroke: 1px #FF285D;
        text-shadow: 0px 0px 5px #FF3263;
        color: black;
    }
    .selectCustom-option:hover .raceDate {
        color: #FF285D;
    }    

    .isActive:hover .raceName {
        color: #FF285D;
    }

    .isActive .raceName {
        color: #FF285D;
        text-shadow: 0px 0px 5px black;
        /* text-stroke: unset; */
        -webkit-text-stroke: unset;
    }

    @media screen and (max-height: 770px) {
        .selectWrapper {
            top: 8px;
        }
    }

   
</style>